import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Hotkey, Hotkeys, HotkeysTarget } from '@blueprintjs/core';
import styled from 'styled-components';
import { get as _get } from 'lodash';
import { Row, Col } from 'reactstrap';
import { createForm } from 'rc-form';
import * as _ from 'lodash';

import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { setMenuSelected } from '@redux/actions/menuAction';
import { getList, exportData } from 'api/facilityeiaApi';
import { DATE_FORMAT } from 'config';
import slug from 'constants/slug';
import PageLockHOC from 'hoc/pageLock';
import Clearfix from 'components/elements/clearfix';
import YearSelect from 'components/elements/select-year';
// import FacilitySelect from 'components/elements/select-facility';
import LoaiHoSoSelect from 'components/elements/select-loai-ho-so';
import { COLOR } from 'config';
import { getLabelIndustrialArea } from 'utils/misc';
import { IS_ENTERPRISE } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

@PageLockHOC(['facilityeia.view'])
@HotkeysTarget
class FacilityeiaList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {
      getList,
      exportData,
    };
    const columns = [
      {
        dataField: 'facility.FacilityNameFull',
        text: 'Tên cơ sở/dự án ',
        formatter: (cell, row) => {
          return (
            <Link to={slug.FACILITY_EIA.VIEW_WITH_ID + row._id} target='_blank'>
              <NameContainer>{cell}</NameContainer>
            </Link>
          );
        },
      },
      ...(!IS_ENTERPRISE && [
        {
          dataField: 'facility.organizationName',
          text: 'Tên doanh nghiệp',
          formatter: (cell, row) => {
            return <div>{cell ? cell : ''}</div>;
          },
        },
      ]),
      {
        dataField: 'facility.industrialArea.Name',
        text: getLabelIndustrialArea(),
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'facility.sector.Name',
        text: 'Ngành/Nghề',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'Title',
        text: 'Tên hồ sơ',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'DecisionNumber',
        text: 'Số quyết định',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'DateIssued',
        text: 'Ngày phát hành',
        formatter: (cell, row) => {
          if (!cell) return '';
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'IssuingAgency',
        text: 'Cơ quan cấp',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'EIAURL',
        text: 'Đường dẫn (URL)',
        formatter: (cell, row) => {
          if (!cell) {
            return null;
          }
          return (
            <a href={`${cell}`} target='_blank'>
              <NameContainer>{cell}</NameContainer>
            </a>
          );
        },
      },
    ];

    super(
      props,
      funcApi,
      columns,
      `${slug.FACILITY_EIA.CREATE}?facilityId=${props.facilityId}`,
      'facilityeia',
      null,
      true,
      true,
      false,
      `Tên cơ sở/dự án ${IS_ENTERPRISE ? '' : 'hoặc Tên doanh nghiệp '}hoặc Số quyết định`
    );

    this.state = {
      ...this.state,
      valueSearch: {
        facility: this.props.facilityId,
      },
    };
  }
  renderHotkeys() {
    return (
      <Hotkeys>
        <Hotkey
          //global={true}
          allowInInput={true}
          combo='enter'
          label='Be awesome all the time'
          onKeyDown={this.handelSubmitSearch}
        />
      </Hotkeys>
    );
  }
  renderSearchContainer() {
    return (
      <div>
        {super.renderSearchContainer()}
        {this.renderSearchExpandContainer()}
      </div>
    );
  }

  handelSubmitSearch = () => {
    this.props.form.validateFields((error, value) => {
      if (error) return;
      value.district = _.get(value.district, 'value');
      value.Commune = _.get(value.Commune, 'value');
      value.sector = _.get(value.sector, 'value');
      value.authority = _.get(value.authority, 'value');
      value.bentrongngoaiSelect = _.get(value.bentrongngoaiSelect, 'value');
      value.industrialArea = _.get(value.industrialArea, 'value');
      value.ReceviedSource_1 = _.get(value.ReceviedSource_1, 'value');
      value.ReceviedSource_2 = _.get(value.ReceviedSource_2, 'value');
      value.facilityParent = _.get(value.facilityParent, 'value');
      value.businessActivity = _.get(value.businessActivity, 'value');
      value.DateIssued = _get(value.DateIssued, 'value');
      if (value.DateIssued) {
        value.DateIssued = [
          moment().year(value.DateIssued).startOf('year').toDate(),
          moment().year(value.DateIssued).endOf('year').toDate(),
        ];
      }

      value.Title = _.get(value.Title, 'value');
      super.handelSubmitSearch(value);
    });
  };

  renderSearchExpandContainer = () => {
    const form = this.props.form;
    return (
      <div>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LoaiHoSoSelect
              label={'Tên hồ sơ'}
              fieldForm={{
                form: form,
                name: 'Title',
              }}
            />
          </Col>
          <Col xs={4}>
            <YearSelect
              label='Năm phát hành'
              fieldForm={{
                form: form,
                name: 'DateIssued',
              }}
            />
          </Col>
        </Row>
      </div>
    );
  };
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(createForm()(FacilityeiaList))
);



// WEBPACK FOOTER //
// ./src/containers/FacilityeiaContainer/FacilityeiaList/index.js